import { useEffect } from 'react';

import RadioButton from '../../../components/radio-button';
import Checkbox from "../../../components/checkbox";

export default function QuestionTypeRadioButtons({ question, params, onChange, validation, addError, error, showErrors, setValidation, handleQuestionChange, getQuestionValue, blockId, sectionId }) {
    const onComponentChange = (e, index) => {

        const updated = [e.option];

        onChange(updated, blockId, question.id, index, question);

        setError(updated);
    }

    const setError = (values= []) => {
        let errors = [];
        if(question.response_required) {
            if(values.length < 1) {
                errors.push('You must select at least one option');
            }
        }

        addError(errors.length >= 1, errors, sectionId, question.id, question);
    }

    useEffect(() => {
        setError(getQuestionValue(sectionId, blockId, question.id) || []);
    }, [])

    let valuesByOption = {};

    const val = getQuestionValue(sectionId, blockId, question.id);
    if(Array.isArray(val)) {
        _.each(val, v => {
            valuesByOption[v] = true;
        });

    }

    return (
        <div className="section-content__container">
            { params.label && <p className="section-content__label">{ params.label }</p> }
            { params.description && <p className="section-content__label" dangerouslySetInnerHTML={{ __html: params.description }}></p> }

            <div className="utils__row utils__gap--20">
                { question.radio_buttons.map((item, index) => {

                    return <RadioButton checked={valuesByOption[item.option]} onChange={(e) => onComponentChange(e, index)} text={item.option} { ...params }/>
                })}
            </div>
            { showErrors && error.length > 0 &&
                <div className="section-content__errors">
                    { error.map(err => <p className="section-content__error">{ err }</p>)}
                </div>
            }
        </div>
    )
}
